import React, { useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Divider,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Chip,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CodeBlock from "./CodeBlock";
const PAYMENT_METHODS: {
  currency: string;
  methods: { code: string; label: string }[];
  symbol: string;
  description?: string;
}[] = [
  {
    currency: "RUB",
    symbol: "₽",
    methods: [
      { code: "rub_card_number", label: "Card transfer (card number)" },
      { code: "rub_fps", label: "Fast Payment System (SBP)" },
      { code: "rub_transgran_card", label: "Transgran card transfer" },
      { code: "rub_transgran_phone", label: "Transgran phone transfer" },
      { code: "rub_mob_com", label: "Mobile balance transfer" },
      { code: "rub_transgran_qr_vnd", label: "Transgran QR transfer (VND)" },
      {
        code: "rub_transgran_card_tjs",
        label: "Transgran card transfer (TJS)",
      },
      {
        code: "rub_transgran_card_uzs",
        label: "Transgran card transfer (UZS)",
      },
    ],
  },
  {
    currency: "IDR",
    symbol: "Rp",
    methods: [{ code: "idr_qris", label: "QRIS payment" }],
  },
  {
    currency: "PKR",
    symbol: "Rs",
    methods: [
      { code: "pkr_jazz", label: "Jazz Cash JZ" },
      { code: "pkr_ep", label: "Easy Paisa EP" },
    ],
  },
  {
    currency: "TRY",
    symbol: "₺",
    methods: [
      { code: "try_bank_transfer", label: "Bank transfer" },
      { code: "try_havale", label: "Havale" },
    ],
  },
  {
    currency: "KGS",
    symbol: "С",
    methods: [{ code: "kgs_card_transfer", label: "Card transfer" }],
  },
  {
    currency: "BOL",
    symbol: "b$",
    methods: [
      { code: "bol_bank_transfer", label: "Bank transfer" },
      { code: "bol_qr_code", label: "QR code payment" },
    ],
  },
  {
    currency: "VES",
    symbol: "Bs",
    methods: [
      { code: "ven_pago_movil", label: "Pago Móvil" },
      { code: "ven_qr_code", label: "QR code payment" },
      { code: "ven_account_number", label: "Bank account transfer" },
    ],
  },
  {
    currency: "ECU",
    symbol: "S",
    methods: [
      { code: "ecu_account_number", label: "Bank account transfer" },
      { code: "ecu_phone_number", label: "Phone number transfer" },
    ],
  },
  {
    currency: "KRW",
    symbol: "₩",
    methods: [
      { code: "krw_bank_transfer", label: "Bank transfer" },
      { code: "krw_kakao_pay", label: "Kakao Pay" },
    ],
  },
  {
    currency: "ARS",
    symbol: "$",
    methods: [
      { code: "ars_mercado_pago", label: "Mercado Pago" },
      { code: "ars_lemon_cash", label: "Lemon Cash" },
    ],
  },
  {
    currency: "INR",
    symbol: "₹",
    methods: [{ code: "inr_upi_intent", label: "UPI Intent" }],
  },
  {
    currency: "BDT",
    symbol: "৳",
    methods: [
      { code: "bdt_bkash", label: "bKash wallet payment" },
      { code: "bdt_nagad", label: "Nagad wallet payment" },
      { code: "bdt_upay", label: "Upay wallet payment" },
    ],
  },
  {
    currency: "VND",
    symbol: "₫",
    methods: [
      { code: "vnd_qr_code", label: "VietQR payment" },
      { code: "vnd_momo", label: "MoMo wallet payment" },
      { code: "vnd_viettel", label: "Viettel wallet/mobile payment" },
      { code: "vnd_ewallet", label: "E wallet" },
    ],
  },
  {
    currency: "PHP",
    symbol: "₱",
    methods: [
      { code: "php_gcash", label: "GCash Native payment" },
      { code: "php_maya", label: "Maya wallet payment" },
      { code: "php_mayab", label: "MayaB payment method" },
    ],
  },
  {
    currency: "KZT",
    symbol: "₸",
    methods: [
      { code: "kzt_card_transfer", label: "Card transfer" },
      { code: "kzt_phone_transfer", label: "Phone transfer" },
    ],
  },
  {
    currency: "AZN",
    symbol: "₼",
    methods: [
      { code: "azn_card_number", label: "Card transfer" },
      { code: "azn_quazi", label: "Quazi Ecom" },
      { code: "azn_wallet", label: "E Wallet" },
    ],
  },
  {
    currency: "THB",
    symbol: "฿",
    methods: [{ code: "thb_qr", label: "QR payment" }],
    description: `{
  "merchant_id": "order-12345",
  "amount": 1000,
  "payment_method": "thb_qr",
  "user_id": "5436346",
  "bank_name": "KBANK",
  "number": "1234567890",
  "fullname": "Somchai Jaidee"
}`,
  },
];

export const ApiDocGetTransaction: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleChange = (_e: any, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: "95%", margin: "0 auto", marginTop: "20px" }}>
      <Typography variant="body2" gutterBottom>
        Header: <strong>Authorization: Bearer token</strong>
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Tabs */}
      <Tabs
        value={tab}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{ mb: 2 }}
      >
        <Tab label="Request" />
        <Tab label="Response" />
      </Tabs>

      {/* Request */}
      {tab === 0 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Example request
          </Typography>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>id</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Order id in our system.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>merchant_id</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Order id in merchant's system.</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`GET {base_url}/api/v1/info/check_order
Authorization: Bearer <token>
Content-Type: application/json
{
    "id": "pay_001",
    "merchant_id": "mrc_123"
}`}
            </CodeBlock>
          </Box>
        </Box>
      )}

      {/* Response */}
      {tab === 1 && (
        <Box>
          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`{
    "id": "pay_001",
    "merchant_id": "mrc_123",
    "payment_method": "rub_card_number",
    "start_amount": 1250.5,
    "paid_amount": 1200.0,
    "exchange_rate*": 1.0,
    "status": "completed",
    "created_at": "2025-09-26T12:00:00Z",
    "updated_at": "2025-09-26T12:10:00Z"
}`}
            </CodeBlock>
          </Box>
        </Box>
      )}
    </Box>
  );
};
export const ApiDocCreateReceiveOrder: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleChange = (_e: any, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: "95%", margin: "0 auto", marginTop: "20px" }}>
      <Typography variant="body2" gutterBottom>
        Header: <strong>Authorization: Bearer token</strong>
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Tabs */}
      <Tabs
        value={tab}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{ mb: 2 }}
      >
        <Tab label="Request" />
        <Tab label="Response" />
      </Tabs>

      {/* Request */}
      {tab === 0 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Request
          </Typography>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>merchant_id</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>Order id in merchant's system.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>user_id</TableCell>
                <TableCell>string (optional)</TableCell>
                <TableCell>
                  End user identifier (required if antifraud is enabled).
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>amount</TableCell>
                <TableCell>float (required)</TableCell>
                <TableCell>Payment amount.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>user_ip</TableCell>
                <TableCell>string (optional)</TableCell>
                <TableCell>
                  End user IP address (required if antifraud is enabled).
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>payment_method</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>See supported payment methods below</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>bank_name</TableCell>
                <TableCell>string (optional)</TableCell>
                <TableCell>Bank name (if applicable).</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>email</TableCell>
                <TableCell>string (optional)</TableCell>
                <TableCell>User's email (only for Quazi method)</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>card_data</TableCell>
                <TableCell>object (only for Quazi method)</TableCell>
                <TableCell>Card data object.</TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={{ pl: 4 }}>holder</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>Card holder name.</TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={{ pl: 4 }}>number</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>Card number.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ pl: 4 }}>expiry</TableCell>
                <TableCell>object (required)</TableCell>
                <TableCell>Expiry data object</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ pl: 6 }}>month</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>Card expiration month (MM).</TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={{ pl: 6 }}>year</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>Card expiration year (YY).</TableCell>
              </TableRow>

              <TableRow>
                <TableCell sx={{ pl: 4 }}>cvc</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>Card security code.</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Typography variant="h6" gutterBottom mt={3} mb={1}>
            Supported payment methods
          </Typography>

          <Box
            mt={1}
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              overflow: "hidden",
              backgroundColor: "background.paper",
            }}
          >
            {PAYMENT_METHODS.map(
              ({ currency, methods, symbol, description }) => (
                <Accordion
                  sx={{
                    boxShadow: "none",
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    "&:before": { display: "none" },
                    "&.Mui-expanded": {
                      margin: 0,
                    },
                    "& .MuiAccordionSummary-root:hover": {
                      backgroundColor: "action.hover",
                    },
                  }}
                  key={currency}
                >
                  <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls={`${currency}-content`}
                    id={`${currency}-header`}
                  >
                    <Chip label={`${symbol} ${currency}`} size="small" />{" "}
                  </AccordionSummary>

                  <AccordionDetails
                    sx={{
                      backgroundColor: "background.default",
                      px: 2,
                      py: 1.5,
                    }}
                  >
                    <Stack spacing={1}>
                      {methods.map((method, idx) => (
                        <Box
                          key={method.code}
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          py={0.5}
                          borderBottom={
                            idx !== methods.length - 1 ? "1px dashed" : "none"
                          }
                          borderColor="divider"
                        >
                          <Typography
                            variant="body2"
                            fontFamily="monospace"
                            sx={{ color: "accentText" }}
                          >
                            {method.code}
                          </Typography>
                          <Typography variant="body2">
                            {method.label}
                          </Typography>
                        </Box>
                      ))}
                    </Stack>
                    {description && (
                      <Box mt={2}>
                        <Divider sx={{ mb: 1.5 }} />
                        <Typography variant="subtitle2" gutterBottom>
                          Example request
                        </Typography>
                        <CodeBlock>{description}</CodeBlock>
                      </Box>
                    )}
                  </AccordionDetails>
                </Accordion>
              ),
            )}
          </Box>

          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`{
    "amount": 1250.5,
    "payment_method": "rub_card_number",
    "merchant_id": "mrc_123",
    "user_id": "usr_42",
    "user_ip": "203.0.113.5",
    "email": "test124@gmail.com
    "card_data": {
      "holder": "John Doe",
      "number": "7601251042367488",
      "expiry": {
          "year": "33",
          "month": "10"
      },
      "cvc": "123"
    }
}`}
            </CodeBlock>
          </Box>
        </Box>
      )}

      {/* Response */}
      {tab === 1 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Response
          </Typography>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>id</TableCell>
                <TableCell>{`string<uuid>`}</TableCell>
                <TableCell>Order id in our system.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>merchant_order_id</TableCell>
                <TableCell>{`string<uuid>`}</TableCell>
                <TableCell>Order id in merchant's system.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>start_amount</TableCell>
                <TableCell>float</TableCell>
                <TableCell>Payment amount.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>exchange_rate</TableCell>
                <TableCell>float</TableCell>
                <TableCell>Applied exchange rate.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>requisites.number</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Payment account/number.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>requisites.fullname</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Beneficiary full name.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>requisites.bank</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Bank name.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>requisites.qr_code</TableCell>
                <TableCell>string</TableCell>
                <TableCell>QR code payload.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>payment_method</TableCell>
                <TableCell>string</TableCell>
                <TableCell>One of allowed values.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>status</TableCell>
                <TableCell>string</TableCell>
                <TableCell>created | completed | canceled | dispute</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>pay_timer</TableCell>
                <TableCell>integer</TableCell>
                <TableCell>Time to pay (seconds).</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>payment_form_link</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Hosted payment form link.</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`{
      "id": "pay_001",
      "merchant_order_id": "mrc_123",
      "start_amount": 1250.5,
      "exchange_rate*": 1.0,
      "requisites": {
      "number": "string",
      "fullname": "string",
      "bank": "string",
      "qr_code": "string"
      },
      "payment_method": "rub_card_number",
      "status": "created",
      "pay_timer": 1800,
      "payment_form_link": "string"
}`}
            </CodeBlock>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export const ApiDocCreateOrder: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleChange = (_e: any, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: "95%", margin: "0 auto", marginTop: "20px" }}>
      <Typography variant="body2" gutterBottom>
        Header:: <strong>Authorization: Bearer token</strong>
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Tabs */}
      <Tabs
        value={tab}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{ mb: 2 }}
      >
        <Tab label="Request" />
        <Tab label="Response" />
      </Tabs>

      {/* Request */}
      {tab === 0 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Request
          </Typography>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>amount</TableCell>
                <TableCell>float (required)</TableCell>
                <TableCell>Payout amount.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>payment_method</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>See supported payment methods below </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>bank_name</TableCell>
                <TableCell>string (optional)</TableCell>
                <TableCell>Bank name (if applicable).</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>number</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>Destination account/number.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>qr_code</TableCell>
                <TableCell>string (required for QR methods)</TableCell>
                <TableCell>
                  Data required to generate the payment QR code.
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>merchant_id</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>Order id in merchant's system.</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Typography variant="h6" gutterBottom mt={3} mb={1}>
            Supported payment methods
          </Typography>

          <Box
            mt={1}
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              overflow: "hidden",
              backgroundColor: "background.paper",
            }}
          >
            {PAYMENT_METHODS.map(({ currency, methods, symbol }) => (
              <Accordion
                sx={{
                  boxShadow: "none",
                  borderBottom: "1px solid",
                  borderColor: "divider",
                  "&:before": { display: "none" },
                  "&.Mui-expanded": {
                    margin: 0,
                  },
                  "& .MuiAccordionSummary-root:hover": {
                    backgroundColor: "action.hover",
                  },
                }}
                key={currency}
              >
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls={`${currency}-content`}
                  id={`${currency}-header`}
                >
                  <Chip label={`${symbol} ${currency}`} size="small" />{" "}
                </AccordionSummary>

                <AccordionDetails
                  sx={{
                    backgroundColor: "background.default",
                    px: 2,
                    py: 1.5,
                  }}
                >
                  <Stack spacing={1}>
                    {methods.map((method, idx) => (
                      <Box
                        key={method.code}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        py={0.5}
                        borderBottom={
                          idx !== methods.length - 1 ? "1px dashed" : "none"
                        }
                        borderColor="divider"
                      >
                        <Typography
                          variant="body2"
                          fontFamily="monospace"
                          sx={{ color: "accentText" }}
                        >
                          {method.code}
                        </Typography>
                        <Typography variant="body2">{method.label}</Typography>
                      </Box>
                    ))}
                  </Stack>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`{
    "amount": 950.0,
    "payment_method": "bol_bank_transfer",
    "bank_name": "string",
    "number": "string",
    "merchant_id": "mrc_123"
}`}
            </CodeBlock>
          </Box>
        </Box>
      )}

      {/* Response */}
      {tab === 1 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Response
          </Typography>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>id</TableCell>
                <TableCell>{`string<uuid>`}</TableCell>
                <TableCell>Order id in our system.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>merchant_order_id</TableCell>
                <TableCell>{`string<uuid>`}</TableCell>
                <TableCell>Order id in merchant's system.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>start_amount</TableCell>
                <TableCell>float</TableCell>
                <TableCell>Payout amount.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>exchange_rate</TableCell>
                <TableCell>float</TableCell>
                <TableCell>Applied exchange rate.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>payment_method</TableCell>
                <TableCell>string</TableCell>
                <TableCell>One of allowed values. </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>currency</TableCell>
                <TableCell>string</TableCell>
                <TableCell>currency of the transaction. </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>fullname</TableCell>
                <TableCell>string</TableCell>
                <TableCell>user's fullname</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>bank_name</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Bank name</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>number</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Requisite of the receiver</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>status</TableCell>
                <TableCell>string</TableCell>
                <TableCell>created | completed | canceled | dispute</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`{
    "id": "out_001",
    "merchant_order_id": "mrc_123",
    "start_amount": 950.0,
    "exchange_rate*": 5.21,
    "payment_method": "bol_bank_transfer",
    "status": "created",
    "number": '2202555222555',
    "bank_name": 'Jusan Bank',
    "fullname": 'Test',
    "currency": 'BOL'
}`}
            </CodeBlock>
          </Box>
        </Box>
      )}
    </Box>
  );
};
export const ApiDocGetBalance: React.FC = () => {
  return (
    <Box sx={{ width: "95%", margin: "0 auto", marginTop: "20px" }}>
      <Typography variant="body2" gutterBottom>
        Header: <strong>Authorization: Bearer token</strong>
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Box>
        <Box mt={2}>
          <Typography variant="h6" gutterBottom>
            Example:
          </Typography>
          <CodeBlock>
            {`{
  "deposit": {
      "fiat": {
        "krw": 0.0,
        "rub": 0.0,
        "bol": 0.0,
        "ars": 0.0,
        "ves": 0.0,
        "inr": 0.0,
        "bdt": 0.0
      },
      "usdt": 0.0
    },
  "payout": {
      "fiat": {
        "krw": 0.0,
        "rub": 0.0,
        "bol": 0.0,
        "ars": 0.0,
        "ves": 0.0,
        "inr": 0.0,
        "bdt": 0.0
      },
      "usdt": 0.0
    },
  "frozen": {
      "fiat": {
        "krw": 0.0,
        "rub": 0.0,
        "bol": 0.0,
        "ars": 0.0,
        "ves": 0.0,
        "inr": 0.0,
        "bdt": 0.0
      },
      "usdt": 0.0
    }
}`}
          </CodeBlock>
        </Box>
      </Box>
    </Box>
  );
};
export const ApiDocCreateApeal: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleChange = (_e: any, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: "95%", margin: "0 auto", marginTop: "20px" }}>
      <Typography variant="body2" gutterBottom>
        Header: <strong>Authorization: Bearer token</strong>
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Tabs */}
      <Tabs
        value={tab}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{ mb: 2 }}
      >
        <Tab label="Request" />
        <Tab label="Response" />
      </Tabs>

      {/* Request */}
      {tab === 0 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Request
          </Typography>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>merchant_id</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>Order id in merchant's system.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>id</TableCell>
                <TableCell>string (required)</TableCell>
                <TableCell>Order id in our system. </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>comment</TableCell>
                <TableCell>string (optional)</TableCell>
                <TableCell>Free-form comment..</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`{
    "merchant_id": "mrc_123",
    "id": "pay_001",
    "comment": "string"
}`}
            </CodeBlock>
          </Box>
        </Box>
      )}

      {/* Response */}
      {tab === 1 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Response
          </Typography>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>id</TableCell>
                <TableCell>{`string<uuid>`}</TableCell>
                <TableCell>Order id in our system.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>merchant_id</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Order id in merchant's system.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>comment</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Comment text.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>start_amount</TableCell>
                <TableCell>float</TableCell>
                <TableCell>Initial amount.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>paid_amount</TableCell>
                <TableCell>float</TableCell>
                <TableCell>Confirmed paid amount.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>created</TableCell>
                <TableCell>datetime</TableCell>
                <TableCell>Creation time.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>updated</TableCell>
                <TableCell>datetime</TableCell>
                <TableCell>Last update time.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>file</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Attached file name / url.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>status</TableCell>
                <TableCell>string</TableCell>
                <TableCell>dispute.</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`{
    "id": "app_001",
    "merchant_id": "mrc_123",
    "comment": "string",
    "start_amount": 1250.5,
    "paid_amount": 1200.0,
    "created": "2025-09-27T03:21:00Z",
    "updated": "2025-09-27T03:21:00Z",
    "file": "string",
    "status": "dispute"
}`}
            </CodeBlock>
          </Box>
        </Box>
      )}
    </Box>
  );
};
export const ApiDocAttachFile: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleChange = (_e: any, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: "95%", margin: "0 auto", marginTop: "20px" }}>
      <Typography variant="body2" gutterBottom>
        Request: <strong>multipart/form-data</strong>
      </Typography>
      <Typography variant="body2" gutterBottom>
        Query parameter: <strong>id (string, required)</strong>
      </Typography>
      <Typography variant="body2" gutterBottom>
        Header: <strong>Authorization: Bearer token</strong>
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Tabs */}
      <Tabs
        value={tab}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{ mb: 2 }}
      >
        <Tab label="Request" />
        <Tab label="Response" />
      </Tabs>

      {/* Request */}
      {tab === 0 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Request — Query parameters
          </Typography>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>id</TableCell>
                <TableCell>string(required)</TableCell>
                <TableCell>Order id in our system.</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Typography variant="h6" gutterBottom>
            Request — Body
          </Typography>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>file</TableCell>
                <TableCell>{`string<binary>`}</TableCell>
                <TableCell>Appeal attachment file.</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`POST {base_url}/api/v1/payments/appeal_file
Authorization: Bearer <token>
Content-Type: multipart/form-data
--boundary
Content-Disposition: form-data; name="id"
pay_001
--boundary
Content-Disposition: form-data; name="file"; filename="evidence.pdf"
Content-Type: application/pdf
<binary>
--boundary--`}
            </CodeBlock>
          </Box>
        </Box>
      )}

      {/* Response */}
      {tab === 1 && (
        <Box>
          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`{
    "id": "app_001",
    "merchant_id": "mrc_123",
    "comment": "string",
    "start_amount": 1250.5,
    "paid_amount": 1200.0,
    "created": "2025-09-27T03:21:00Z",
    "updated": "2025-09-27T03:21:00Z",
    "file": "string",
    "status": "dispute"
}`}
            </CodeBlock>
          </Box>
        </Box>
      )}
    </Box>
  );
};
export const ApiDocWebHook: React.FC = () => {
  return (
    <Box sx={{ width: "95%", margin: "0 auto", marginTop: "20px" }}>
      <Typography variant="body2" gutterBottom>
        Body: <strong>application/json</strong>
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Box>
        <Typography variant="h6" gutterBottom>
          Request — Query parameters
        </Typography>
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell>id</TableCell>
              <TableCell>string</TableCell>
              <TableCell>Order id in our system.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>merchant_order_id</TableCell>
              <TableCell>string</TableCell>
              <TableCell>Order id in merchant's system.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>payment_method</TableCell>
              <TableCell>string</TableCell>
              <TableCell>Payment method used.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>start_amount</TableCell>
              <TableCell>float</TableCell>
              <TableCell>Order amount at creation.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>paid_amount</TableCell>
              <TableCell>float</TableCell>
              <TableCell>Confirmed paid amount.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>exchange_rate*</TableCell>
              <TableCell>float</TableCell>
              <TableCell>Applied exchange rate.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>status</TableCell>
              <TableCell>string</TableCell>
              <TableCell>Current order status.</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>updated_at</TableCell>
              <TableCell>datetime</TableCell>
              <TableCell>Last update timestamp (ISO8601).</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>signature</TableCell>
              <TableCell>string</TableCell>
              <TableCell>Signature to verify payload authenticity.</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Box mt={2}>
          <Typography variant="h6" gutterBottom>
            Signature generation (Python):
          </Typography>
          <CodeBlock>
            {`signature_pre_hash = f"{int(data['start_amount'])}:{data['id']}:{merchant_api_key}"
signature = hash('sha256', signature_pre_hash)`}
          </CodeBlock>
        </Box>
        <Box mt={2}>
          <Typography variant="h6" gutterBottom>
            Example:
          </Typography>
          <CodeBlock>
            {`data = {
    "amount" : 1023.56,
    "id" : "2e9ce49b-917b-489a-847e-227b21fe6c4a",
    ...
}
api_key = 'NG4ei5c0vbsa3yr2tvtBStxzvWox912vsT3ixb4zK5SnJDl81xnn'`}
          </CodeBlock>
        </Box>{" "}
        <Box mt={2}>
          <Typography variant="h6" gutterBottom>
            For the data above, signature will be:
          </Typography>
          <CodeBlock>
            {`569b3bd0e9127cc194a44fc7c8040ab40aea70d6b413d5935b17fda732cd7b06`}
          </CodeBlock>
        </Box>
      </Box>
    </Box>
  );
};

export const ApiDocConfirm: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleChange = (_e: any, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: "95%", margin: "0 auto", marginTop: "20px" }}>
      <Typography variant="body2" gutterBottom>
        Header: <strong>Authorization: Bearer token</strong>
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Tabs */}
      <Tabs
        value={tab}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{ mb: 2 }}
      >
        <Tab label="Request" />
        <Tab label="Response" />
      </Tabs>

      {/* Request */}
      {tab === 0 && (
        <Box>
          <Typography variant="h6" gutterBottom>
            Example request
          </Typography>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell>order_id</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Order id in our system.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>reference_id</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Banking id.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>phone_number</TableCell>
                <TableCell>string</TableCell>
                <TableCell>Phone number of the user</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`PUT {base_url}/api/v1/payments/reference
Authorization: Bearer <token>
Content-Type: application/json
{
    "order_id": "pay_001",
    "reference_id": "pay_002",
    "phone_number": "77777777777"
}`}
            </CodeBlock>
          </Box>
        </Box>
      )}

      {/* Response */}
      {tab === 1 && (
        <Box>
          <Box mt={2}>
            <Typography variant="h6" gutterBottom>
              Example:
            </Typography>
            <CodeBlock>
              {`{
  "detail": "ok"
}`}
            </CodeBlock>
          </Box>
        </Box>
      )}
    </Box>
  );
};
